<template>
  <v-data-table
    :headers="headers"
    :items="listEmployeeAllowance"
    sort-by="no"
    dense
    @click:row="onClickRow"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="success"
              v-on="on"
              dark
              rounded
              :to="{ name: 'Create Employee Allowance' }"
            >
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Create</span>
        </v-tooltip>
      </v-toolbar>
    </template>
    <template v-slot:item.no="{ item }">
      {{ listEmployeeAllowance.map(x => x).indexOf(item) + 1 }}
    </template>
    <template v-slot:item.amount="{ item }">
      {{ item.amount ? item.amount.toLocaleString() : 0 }}
    </template>
    <template v-slot:item.threshold="{ item }">
      {{ item.threshold ? item.threshold.toLocaleString() : 0 }}
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    headers: [
      {
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Employee Name",
        value: "employeeName",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Department",
        value: "departmentName",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Threshold",
        value: "threshold",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
  }),

  computed: {
    ...mapState("employeeAllowance", ["listEmployeeAllowance"]),
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("employeeAllowance/getAll");
    },
    onClickRow(item) {
      this.$router.push({ name: "Detail Employee Allowance", params: { id: item.id } });
    },
  },
};
</script>

<style></style>
